// React imports.
import React from "react";


// App imports.
import Assessment3bMainTableRow from "./Assessment3bMainTableRow";

const Assessment3bMainTable = ({ state, step, holder, fieldChangeHandler }) => (
    <div>
        {step.showBothAndNumAndPctAndStatus !== true
        &&
        <div className="vendorsReportedGrid">
            <div className="header">Main Heating Fuel</div>
            <div className="header">Total # of Assisted Households</div>
            {step.showMainHeatAndElectric === true &&
                <div className="header"># Households with Billing Data for Both Main Heating and Electric Baseload</div>
            }
            {step.showMainHeat === true &&
                <div className="header"># of Households with Main Heating Fuel Data Available</div>
            }
            {step.showElectricBaseload === true &&
                <div className="header"># of Households with Electric Baseload Data Available</div>
            }
            {(step.showAllFuels === true
                || step.currentFuelName === holder.NaturalGas.name)
                &&
                <Assessment3bMainTableRow rowClass={state.getGridRowBoundaryClass(step.showAllFuels, holder.NaturalGas.name )} fieldChangeHandler={fieldChangeHandler}  step={step} state={state} fuel={holder.NaturalGas} />
            }
            {(step.showAllFuels === true
                || step.currentFuelName === holder.FuelOil.name)
                &&
                <Assessment3bMainTableRow rowClass={state.getGridRowBoundaryClass(step.showAllFuels, holder.FuelOil.name )} fieldChangeHandler={fieldChangeHandler}  step={step} state={state} fuel={holder.FuelOil} />
            }
            {(step.showAllFuels === true
                || step.currentFuelName === holder.Propane.name)
                &&
                <Assessment3bMainTableRow rowClass={state.getGridRowBoundaryClass(step.showAllFuels, holder.Propane.name )}fieldChangeHandler={fieldChangeHandler}  step={step} state={state} fuel={holder.Propane} />
            }
        </div>}


        {step.showBothAndNumAndPctAndStatus === true &&
            <div className="grid-container">
                <div className="grid-item colboundary1_2 rowboundary1_3 header">Main Heating Fuel</div>
                <div className="grid-item colboundary2_3 rowboundary1_3 header">Total # of Assisted Households</div>
                <div className="grid-item colboundary3_5 rowboundary1_2 header"># Households with Billing Data for Both  Main Heating and Electric Baseload</div>
                <div className="grid-item colboundary5_7 rowboundary1_2 header"># of Households with Main Heating Fuel Data Available</div>
                <div className="grid-item colboundary7_9 rowboundary1_2 header"># of Households with Electric Baseload Data Available</div>
                <div className="grid-item colboundary9_11 rowboundary1_3 header">Status</div>
                <div className="grid-item colboundary3_4 rowboundary2_3 header">#</div>
                <div className="grid-item colboundary4_5 rowboundary2_3 header">%</div>

                <div className="grid-item colboundary5_6 rowboundary2_3 header">#</div>
                <div className="grid-item colboundary6_7 rowboundary2_3 header">%</div>
                <div className="grid-item colboundary7_8 rowboundary2_3 header">#</div>
                <div className="grid-item colboundary8_9 rowboundary2_3 header">%</div>
                {(step.showAllFuels === true
                    || step.currentFuelName === holder.NaturalGas.name)
                    &&
                    <Assessment3bMainTableRow rowClass={state.getGridRowBoundaryClass(step.showAllFuels, holder.NaturalGas.name )} fieldChangeHandler={fieldChangeHandler}  step={step} state={state} fuel={holder.NaturalGas} />
                }
                {(step.showAllFuels === true
                    || step.currentFuelName === holder.FuelOil.name)
                    &&
                    <Assessment3bMainTableRow rowClass={state.getGridRowBoundaryClass(step.showAllFuels, holder.FuelOil.name )} fieldChangeHandler={fieldChangeHandler}  step={step} state={state} fuel={holder.FuelOil} />
                }
                {(step.showAllFuels === true
                    || step.currentFuelName === holder.Propane.name)
                    &&
                    <Assessment3bMainTableRow rowClass={state.getGridRowBoundaryClass(step.showAllFuels, holder.Propane.name )}fieldChangeHandler={fieldChangeHandler}  step={step} state={state} fuel={holder.Propane} />
                }
            </div>
        }
    </div>
);

export default Assessment3bMainTable;
